import React from "react";

/**
 * Big colored event button — labels auto-shrink to fit.
 */
export default function CodeEventButton({ label, dose, theme, Icon, onTap, testid, big }) {
  const t = theme || THEMES.gray;
  return (
    <button
      onClick={onTap}
      data-testid={testid}
      className={`relative rounded-2xl p-3 sm:p-4 text-left transition-all active:scale-[0.97] hover:brightness-110 border overflow-hidden ${t.border} ${t.bg} ${big ? "min-h-[110px]" : "min-h-[96px]"}`}
    >
      <div className={`h-7 w-7 sm:h-9 sm:w-9 rounded-full grid place-items-center ${t.iconBg} mb-1.5 sm:mb-2`}>
        {Icon && <Icon className="h-4 w-4 sm:h-5 sm:w-5 text-white" strokeWidth={2} />}
      </div>
      <div className={`text-sm sm:text-base lg:text-lg font-bold tracking-wide ${t.text} leading-tight break-words`}>
        {label}
      </div>
      {dose && (
        <div className={`text-[10px] sm:text-xs font-mono mt-0.5 ${t.text} opacity-80 truncate`}>
          {dose}
        </div>
      )}
    </button>
  );
}

export const THEMES = {
  green:   { bg: "bg-emerald-900/40", border: "border-emerald-500/40", text: "text-emerald-200", iconBg: "bg-emerald-600" },
  orange:  { bg: "bg-amber-900/40",   border: "border-amber-500/40",   text: "text-amber-200",   iconBg: "bg-amber-600"   },
  purple:  { bg: "bg-purple-900/40",  border: "border-purple-500/40",  text: "text-purple-200",  iconBg: "bg-purple-600"  },
  teal:    { bg: "bg-teal-900/40",    border: "border-teal-500/40",    text: "text-teal-200",    iconBg: "bg-teal-600"    },
  yellow:  { bg: "bg-yellow-900/40",  border: "border-yellow-500/40",  text: "text-yellow-200",  iconBg: "bg-yellow-600"  },
  cyan:    { bg: "bg-cyan-900/40",    border: "border-cyan-500/40",    text: "text-cyan-200",    iconBg: "bg-cyan-600"    },
  sky:     { bg: "bg-sky-900/40",     border: "border-sky-500/40",     text: "text-sky-200",     iconBg: "bg-sky-600"     },
  red:     { bg: "bg-red-900/40",     border: "border-red-500/40",     text: "text-red-200",     iconBg: "bg-red-600"     },
  gray:    { bg: "bg-slate-800/60",   border: "border-slate-600/40",   text: "text-slate-200",   iconBg: "bg-slate-600"   },
};
